import { API_ERROR_CODES, ONBOARDING_API_BASE_URL } from './index.ts';

type ApiGetPlatformTokenResult = {
  data?: {
    platformToken: string;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiGetPlatformToken = async (csrfToken: string): Promise<ApiGetPlatformTokenResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/platform-token`, {
    method: 'GET',
    cache: 'no-store',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson } as ApiGetPlatformTokenResult;
    })
    .catch(() => {
      return {
        errorCode: API_ERROR_CODES.GENERIC,
      };
    });
};
